<script>
  import RepTable from './RepTable.svelte';
  import Photos from './../Photos.svelte';
  import IssueCard from './IssueCard.svelte';
  import StaticMap from './StaticMap.svelte';
  import { staticMapURLsDict } from '../../stores';
  import Slides from './slides/Slides.svelte';
  import PrintSection from "./PrintSection.svelte";
  import Note from './../Note.svelte';

  import { byLocale, __, t, __c } from '../../utils/i18n';
  import { districtNames } from '../../utils/copy';

  /**
   * @type {any[]}
   */
  export let data;
  /**
   * @type {any[]}
   */
  export let issuesList;

  /**
   * @type {boolean}
   */
  export let isCity;
  /**
   * @type {string}
   */
  export let cityName;
  /**
   * @type {any[]}
   */
   export let zonesContent;


  let value = data.id;
  let name = t(districtNames, 'supervisor', {id: value});

  let headers = [name, 'County Representatives'];
  let reps = [[data], data.reps];
  reps[0][0]['office'] = 'Supervisor';

  if (cityName == "Los Angeles"){
    issuesList = issuesList.filter(d=>(d.city == "Los Angeles" | d.issue != "housing"))
  }else{
    issuesList = issuesList.filter(d=>(d.city != "Los Angeles"))
  }

</script>

<section>
  <div class="section county" id="county">
    <div class="title-map">
      <div class="hide-on-desktop hide-on-tablet">
        {@html byLocale(zonesContent, 'heading')}
      </div>

      <StaticMap
        url={$staticMapURLsDict['supervisors']}
        altText={__('Map of Los Angeles County ') + name + __(' outlined')}
        lazyLoad="false"
      />
    </div>
    <div class="content">
      <div class="hide-on-mobile">
        {@html byLocale(zonesContent, 'heading')}
      </div>
      <!-- <p class="description"> -->
        {@html byLocale(zonesContent, 'content')}
      <!-- </p> -->
      <Photos
        lookup={ value < 3 ? 'fruitvendor' : 'gardening' }
        className = ""
        idName = ""
        ariaHidden = "false"
        lazyLoad = "false"
        />
    </div>
    <div class="content contd">
        {#each issuesList as i}
          <IssueCard issue={i} level="county" city={cityName} inc="None" />
        {/each}
      
      <Note />
      <RepTable {reps} {headers} />
      <Photos
        lookup={value < 3 ? 'chains' : 'cones'}
        className = "main-page-img tightimage"
        idName = ""
        ariaHidden = "false"
        lazyLoad = "false"
        />
    </div>
    <Slides
      topHed = {__("Board of Supervisors")}
      title={__("Who the heck is on the Board of Supervisors?")}
      subtitle={__("The county's most powerful people?")}
      level="county"
    />
  </div>
</section>

<PrintSection {reps} {headers} heading={zonesContent[`${__c("heading")}`]} {name} level="county" />

